module.exports = __webpack_public_path__ + "img/open-folder2.a2ca4197.png";